<template>
  <div>
    <header>
      <Header />
    </header>
    <div>
      <div id="main">
        <section class="artWorkCateTop">
          <div v-if="isSelected('/t10s')" class="artWorkCateTopTitle">
            <div class="inner4">
              <h1>東京カメラ部10選</h1>
              <p class="titleSub">The 10 Photographers</p>
            </div><!-- /inner4-->
          </div><!-- /photographersListTitle-->

          <div v-if="isSelected('/t10s')" class="artWorkInfo">
            <div class="inner2">
              <p class="mainTxt">
              2020年に東京カメラ部とその分室で11億人を超える人々が約3,300万作品の中から選んだ作品「10選2020」を中心に新作、自信作を追加。更に2012年、2013年、2014年、2015年、2016年、2017年、2018年、2019年に選ばれた10選メンバーを加えた、10選9世代による合同展示です。<br>
              </p>
              <p class="attention">
              *1 11億人:東京カメラ部とその分室がタイムラインで紹介している作品の2020年延べリーチ（閲覧者）数（Facebook、Instagram、Twitter、Weiboインサイト）に基づく<br>
              *2 約3,300万作品：2020年末迄に東京カメラ部とその分室に投稿いただいた総作品数
              </p>
            </div><!-- /inner2-->
          </div><!-- /artWorkInfo-->

          <div class="artWorkCateTopBody">
            <div class="inner2">
              <div v-if="isSelected('/t10s')" class="listBlock">
                <template v-for="awardType of this.awardTypeList()">
                  <div :key="awardType">
                    <h2>{{awardTypeNames[awardType]}}</h2>
                    <div class="listBlockInner">
                      <template v-for="(winner, index) of winnerList(awardType)">
                        <div :key="winner.id" class="exhibitor" :class="{ rowLast: (index % 5 === 4)}">
                          <div class="thumbnailImg">
                              <router-link :to="workUrl(winner)">
                                <img :src="winner.mainImageUrl" :alt="winner.name" />
                              </router-link>
                          </div>
                          <h3><router-link :to="workUrl(winner)">{{ winner.name }}</router-link></h3>
                        </div>
                      </template>
                    </div><!-- /listBlockInner-->
                  </div>
                </template>
              </div><!-- /listBlock-->

            </div><!-- /inner2-->
          </div><!-- /photographersListBody-->
        </section><!-- /photobook-->

      </div><!-- /main-->
    </div>
    <Footer />
    <div class="actionMenu">
      <UpButton />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['winners', 'winnersByAwardType', 'areas'])
  },
  methods: {
    isSelected (str) {
      return this.$route.path.indexOf(str) >= 0
    },
    getArtworksCode (winner) {
      if (!this.awardTypeCode || !winner) return
      return this.awardTypeCode[winner.awardType]
    },
    setTitleAndDescription (to) {
      document.title = to.meta.title ? to.meta.title : ''
      document
        .querySelector('meta[name="description"]')
        .setAttribute('content', to.meta.desc ? to.meta.desc : '')
    },
    awardTypeList () {
      if (this.isSelected('/t10s')) {
        if (this.$route.params.year === '2012') return [9]
        else if (this.$route.params.year === '2013') return [8]
        else if (this.$route.params.year === '2014') return [7]
        else if (this.$route.params.year === '2015') return [6]
        else if (this.$route.params.year === '2016') return [5]
        else if (this.$route.params.year === '2017') return [4]
        else if (this.$route.params.year === '2018') return [3]
        else if (this.$route.params.year === '2019') return [2]
        else if (this.$route.params.year === '2020') return [1]
        else return [1, 2, 3, 4, 5, 6, 7, 8, 9]
      }
    },
    winnerList (type) {
      return this.winners.filter((winner) => { return winner.awardType === type })
    },
    winnerListByArea (area) {
      const winners = this.winnerList(this.EnumAwardTypeJapan100Views)
      return winners.filter((winner) => {
        if (this.$route.params.pref) {
          return this.$route.params.pref == this.prefecturesAlphabetMap[winner.mainImageTitle] &&
                  this.prefecturesMap[winner.mainImageTitle] === area.name
        } else {
          return this.prefecturesMap[winner.mainImageTitle] === area.name
        }
      })
    },
    workUrl (winner) {
      let path = ''
      if (winner.awardType >= this.EnumAwardTypeTcc10Sen2020 && winner.awardType <= this.EnumAwardTypeTcc10Sen2012) {
        const year = 2021 - winner.awardType
        path = `/t10s/${year}/${winner.id}`
      }
      return path
    },
  },
  created () {
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
</style>
